import { useFeatureIsOn } from '@monofront/business/contexts';
import { FEATURE_FLAG_COBBAI_CHATBOT } from '@monofront/business/constants/featureFlags';
import useChatbotEligibility from './useChatbotEligibility';

// Yuma and Cobbai share the same flag: enabled = Cobbai, disabled = Yuma.
const useIsYumaEnabled = (): boolean => {
  const isCobbaiFeatureOn = useFeatureIsOn(FEATURE_FLAG_COBBAI_CHATBOT);
  const isEligible = useChatbotEligibility();

  return isEligible && !isCobbaiFeatureOn;
};

export default useIsYumaEnabled;
